import {
  AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef,
  Component, DoCheck, ElementRef, forwardRef, Input, Renderer2
} from '@angular/core';
import {BASE_LAYOUT, WizBaseLayout} from '../../core/wiz-base-layout';

/**
 * Groupe affichant ses enfants en alignement vertical
 */
@Component({
  selector: 'wiz-vgroup',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./wiz-vgroup.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: BASE_LAYOUT, useExisting: forwardRef(() => WizVgroup)},
    {provide: WizBaseLayout, useExisting: forwardRef(() => WizVgroup)},
  ]
})
export class WizVgroup extends WizBaseLayout implements AfterContentInit, DoCheck {

  constructor(elementRef: ElementRef, renderer: Renderer2, cdref: ChangeDetectorRef) {
    super(elementRef, renderer, cdref);
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();

    this.ngDoCheck();
  }

  /*
   * Détection de l'injection de composants enfants
   */
  ngDoCheck(): void {
    // Check si le nombre d'enfants a changé
    if (this.children && this.children.length !== this.numChildren) {
      this.numChildren = this.children.length;
      this.applyGap();
    }
  }

  /**
   * Application de l'espace entre les enfants en appliquant des marges css
   */
  applyGap() {
    super.applyGap();
    // Conversion du gap en marges css entre les éléments
    for (const element of this.children) {
      if (this.numChildren === 1) {
        this.renderer.setStyle(element, 'margin', '0px');
      } else if (element === this.children[0] && this.numChildren > 1) {
        this.renderer.setStyle(element, 'margin-bottom', this.gap / 2 + 'px');
      } else if (element === this.children[(this.children.length - 1)]) {
        this.renderer.setStyle(element, 'margin-top', this.gap / 2 + 'px');
      } else {
        this.renderer.setStyle(element, 'margin-bottom', this.gap / 2 + 'px');
        this.renderer.setStyle(element, 'margin-top', this.gap / 2 + 'px');
      }

        // gestion du shrink si height en %, sinon pas d'écrasement
        if(element.style.height && element.style.height.indexOf( '%' ) > -1) {
          this.renderer.setStyle(element, 'flex-shrink', 1);
        } else {
          this.renderer.setStyle(element, 'flex-shrink', 0);
        }
     }
  }

  /**
   * Application de l'alignement horizontal par application du style 'justify-content'
   * @param horizontalAlign 'start', 'center', 'end' ou 'space-between'
   */
  @Input() set horizontalAlign(horizontalAlign: 'start' | 'center' | 'end' | 'space-between') {
    this._horizontalAlign = horizontalAlign;

    if (horizontalAlign === 'end') {
      // Les éléments flexibles sont regroupés à la fin
      this.renderer.setStyle(this.elementRef.nativeElement, 'align-items', 'flex-' + horizontalAlign);
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'align-items', horizontalAlign);
    }

    this.cdref.markForCheck();
  }

  /**
   * Application de l'alignement vertical par application du style 'align-items'
   * @param verticalAlign 'start', 'center', 'end', 'flex-start', 'flex-end' ou 'space-between'
   */
  @Input() set verticalAlign(verticalAlign: 'start' | 'center' | 'end' | 'flex-start' | 'flex-end' | 'space-between') {
    this._verticalAlign = verticalAlign;

    if (verticalAlign === 'end') {
      // Les éléments flexibles sont regroupés à la fin
      this.renderer.setStyle(this.elementRef.nativeElement, 'justify-content', 'flex-' + verticalAlign);
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'justify-content', verticalAlign);
    }

    this.cdref.markForCheck();
  }
}
